import { createSlice } from "@reduxjs/toolkit";
import { EditProductProps } from "../types";

const initialState: EditProductProps = {
  editProductDtl: null,
  productId: null,
};

const editProductDtlReducer = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    setEditProductDtl(state, action) {
      return {
        ...state,
        editProductDtl: action.payload,
      };
    },
    setProductId(state, action) {
      return {
        ...state,
        productId: action.payload, // Set the productId in the state
      };
    },
  },
});

export default editProductDtlReducer.reducer;

export const { setEditProductDtl, setProductId } =
  editProductDtlReducer.actions;
